export default class HighlightController {
  constructor() {
    this.term = '';
  }
  setTerm() {
    let term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    this.term = term;
  }
  mark(element) {
    // If the term is empty, return
    if (this.term === '') return;
    console.log(this.term);

    // Convert the html to a string
    const html = element.innerHTML;
    // Create a new regular expression
    const regex = new RegExp(this.term, 'gi');

    // We need to only update text that is bewteen > and < to avoid adding <mark> tags to attributes, so we split the html into an array
    const htmlArray = html.split(/(<[^>]*>)/g);

    // Loop through the array
    htmlArray.forEach((html, index) => {
      // If the html is text, not a tag
      if (!html.match(/^</)) {
        // Replace the text with the text with the highlighted text
        htmlArray[index] = html.replace(regex, `<mark>$&</mark>`);
      }
    });

    // Join the array back into a string
    element.innerHTML = htmlArray.join('');
  }
}